module.exports = __webpack_public_path__ + "img/program_qr_code.97c6e964.jpg";